var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noList"},[_c('img',{attrs:{"src":require("../../assets/report/noList.png"),"alt":""}}),_vm._t("text")],2)}
var staticRenderFns = []

export { render, staticRenderFns }